import { useContext, useEffect, useState } from 'react';
import { Badge, Grid, IconButton, LinearProgress, Link, Table, TableBody, TableCell, TableFooter, TableHead, TableRow, Tooltip, Typography, Zoom } from '@material-ui/core';
import { ticketContext } from '../../TicketContext';
import Moment from 'react-moment';
import axios from 'axios';
import { ItemListResponse } from 'helpers/interfaces';
import { Link as IconLink, LinkOff, Search } from '@material-ui/icons';

interface IWarrantyRegistation {
    dealerName: string
    registrationDate?: string
    extentionExpireDate?: string
    purchaseDate?: string
    registrationId: string
}

let WarrantyIntegration = () => {
    let { ticket, updateWarrantyRegistration } = useContext(ticketContext);

    const [registrationsIsLoading, setRegistrationsIsLoading] = useState(true);
    const [warrantyRegistrations, setWarrantyRegistrations] = useState<IWarrantyRegistation[]>([]);


    useEffect(() => {
        if (ticket.endCustomersHasRegisteredProduct && ticket.endCustomerEmailAddress)
            updateWarrantyRegistrations()
    }, [ticket.endCustomersHasRegisteredProduct, ticket.productSKU, ticket.endCustomerEmailAddress, ticket.productQRCode]);


    let removeToWarrantyRegistration = async (ticketNr: string) => {
        try {
            await axios.delete(`/api/Ticket/RemoveRegistrationToTickets/${ticketNr}`);
            updateWarrantyRegistration("");
        } catch (error) { }
    }

    let updateWarrantyRegistrations = async () => {
        try {
            setRegistrationsIsLoading(true);
            let res = await axios.get<ItemListResponse<IWarrantyRegistation>>('/api/Ticket/GetWarrantyRegistrations', { params: { ticketNumber: ticket.ticketNumber } });
            setWarrantyRegistrations(res.data.items);
            setRegistrationsIsLoading(false);
        } catch (error) {
            setRegistrationsIsLoading(false);

        }
    }

    let linkToWarrantyRegistration = async (registrationId: string) => {
        try {
            let request = {
                ticketNumber: ticket.ticketNumber,
                registrationId
            }
            await axios.get('/api/Ticket/LinkRegistrationToTickets', { params: request });
            updateWarrantyRegistration(registrationId);
        } catch (error) { }
    }

    return (
        <Grid container>
            <Grid item xs={12}>
                <Typography variant="h4" color="textSecondary">Warranty integration</Typography>
            </Grid>
            <Grid item>
                <Typography variant="subtitle1">End customers has registered product on warranty website&nbsp;&nbsp;</Typography>
            </Grid>
            <Grid item xs>
                <Badge
                    color={ticket.endCustomersHasRegisteredProduct ? "secondary" : "primary"}
                    badgeContent={ticket.endCustomersHasRegisteredProduct ? "YES" : "NO"}
                />
            </Grid>


            {ticket.endCustomersHasRegisteredProduct &&
                <>
                    <Grid item xs={12} />

                    <Grid item xs={6}>
                        <Typography>{ticket.endCustomerEmailAddress || '-'}</Typography>
                        <Typography variant="subtitle1">End customer email address</Typography>
                    </Grid>
                    <Grid item xs>
                        <Typography>{ticket.productQRCode || '-'}</Typography>
                        <Typography variant="subtitle1">Product QRCode</Typography>
                    </Grid>

                    {ticket.endCustomerEmailAddress &&
                        <>
                            {registrationsIsLoading === true &&
                                <Grid item xs={12}>
                                    <Typography variant="subtitle1" >Loading registrations...</Typography>
                                    <LinearProgress />
                                </Grid>
                            }
                            {registrationsIsLoading === false &&
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Dealer name</TableCell>
                                            <TableCell>Registration date</TableCell>
                                            <TableCell>Extention expire date</TableCell>
                                            <TableCell>Purchase date</TableCell>
                                            <TableCell />
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {warrantyRegistrations.map((registration, i) =>
                                            <TableRow
                                                hover
                                                selected={ticket.registrationId === registration.registrationId}
                                                key={registration.registrationId}
                                            >
                                                <TableCell>
                                                    {registration.dealerName}

                                                </TableCell>
                                                <TableCell>
                                                    {registration.registrationDate
                                                        ? <Moment date={registration.registrationDate} format="LL" />
                                                        : '-'
                                                    }
                                                </TableCell>
                                                <TableCell>
                                                    {registration.extentionExpireDate
                                                        ? <Moment date={registration.extentionExpireDate} format="LL" />
                                                        : '-'
                                                    }
                                                </TableCell>
                                                <TableCell>
                                                    {registration.purchaseDate
                                                        ? <Moment date={registration.purchaseDate} format="LL" />
                                                        : '-'
                                                    }
                                                </TableCell>

                                                <TableCell align="right">
                                                    <Link href={`${process.env.REACT_APP_WARRANTY_ADMIN_URL}/registration/${registration.registrationId}`} target={"_blank"}>
                                                        <IconButton size='small'>
                                                            <Search />
                                                        </IconButton>
                                                    </Link>

                                                    {ticket.registrationId !== registration.registrationId &&
                                                        <Tooltip TransitionComponent={Zoom} title="Link Warranty">
                                                            <IconButton size={"small"} onClick={() => {
                                                                if (window.confirm("Do you want to link this product registration to the current Ticket?")) {
                                                                    linkToWarrantyRegistration(registration.registrationId)
                                                                }
                                                            }}>
                                                                <IconLink />
                                                            </IconButton>
                                                        </Tooltip>
                                                    }
                                                    {ticket.registrationId === registration.registrationId &&
                                                        <Tooltip TransitionComponent={Zoom} title="Unlink Warranty">
                                                            <IconButton size={"small"} onClick={() => {
                                                                if (window.confirm("Do you want to remove this product registration to the current Ticket?")) {
                                                                    removeToWarrantyRegistration(ticket.ticketNumber)
                                                                }
                                                            }}>
                                                                <LinkOff />
                                                            </IconButton>
                                                        </Tooltip>
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                    {warrantyRegistrations.length === 0 &&
                                        <TableFooter>
                                            <TableRow>
                                                <TableCell colSpan={5}>
                                                    <i>No registrations found</i>
                                                </TableCell>
                                            </TableRow>
                                        </TableFooter>
                                    }
                                </Table>
                            }
                        </>}


                </>
            }

        </Grid>
    )
}


export default WarrantyIntegration